import { render, staticRenderFns } from "./ClasesDetalleObservaciones.vue?vue&type=template&id=207a958a&"
import script from "./ClasesDetalleObservaciones.vue?vue&type=script&lang=js&"
export * from "./ClasesDetalleObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./ClasesDetalleObservaciones.vue?vue&type=style&index=0&id=207a958a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports